import { IconButton, IconButton_IconSizes, IconButtonSize } from '@ydistri/ds';
import React, { useCallback, useMemo } from 'react';
import { MdOutlineBarChart } from 'react-icons/md';

interface ToggleStatisticsActionProps {
  onClick: () => void;
  disabled?: boolean;
  size?: IconButtonSize;
}

const ToggleStatisticsAction: React.FC<ToggleStatisticsActionProps> = ({
  onClick,
  disabled,
  size = 'normal',
}: ToggleStatisticsActionProps) => {
  const icon = useMemo(() => <MdOutlineBarChart size={IconButton_IconSizes[size]} />, [size]);

  const clickHandler = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      onClick();
    },
    [onClick],
  );

  return (
    <IconButton
      size={size}
      tooltip="Toggle statistics"
      icon={icon}
      onClick={clickHandler}
      disabled={disabled}
    />
  );
};

export default ToggleStatisticsAction;
